
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 994 994"}, attrs),
              ...rest,
            },
            children.concat([_c('linearGradient',{attrs:{"id":"a","gradientUnits":"userSpaceOnUse","x1":"497","y1":"1003","x2":"497","y2":"9.013","gradientTransform":"matrix(1 0 0 -1 0 1003)"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#00b2ff"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#006aff"}})]),_c('path',{attrs:{"fill":"url(#a)","d":"M497 0C217 0 0 205.1 0 482.1 0 627 59.4 752.2 156.1 838.7c8.1 7.3 13 17.4 13.4 28.3l2.7 88.4c.9 28.2 30 46.5 55.8 35.2l98.6-43.5c8.4-3.7 17.7-4.4 26.5-2 45.3 12.5 93.6 19.1 143.9 19.1 280 0 497-205.1 497-482.1S777 0 497 0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M198.6 623.1l146-231.6c23.2-36.8 73-46 107.8-19.9l116.1 87.1c10.7 8 25.3 7.9 35.9-.1l156.8-119c20.9-15.9 48.3 9.2 34.2 31.4L649.5 602.5c-23.2 36.8-73 46-107.8 19.9l-116.1-87.1c-10.7-8-25.3-7.9-35.9.1L232.8 654.5c-20.9 15.9-48.3-9.2-34.2-31.4z"}})])
          )
        }
      }
    